import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'About',      href: '#about' },
  { label: 'Skills',     href: '#skills' },
  { label: 'Experience', href: '#experience' },
  { label: 'Projects',   href: '#projects' },
  { label: 'Education',  href: '#education' },
  { label: 'Contact',    href: '#contact' },
];

export default function Navigation() {
  const [active, setActive] = useState('');
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = ['about', 'skills', 'experience', 'projects', 'education', 'contact'];
      const pos = window.scrollY + 120;
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && pos >= el.offsetTop && pos < el.offsetTop + el.offsetHeight) {
          setActive(id); break;
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 lg:px-16 py-4"
      style={{
        background: scrolled ? 'rgba(10,10,15,0.85)' : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        borderBottom: scrolled ? '1px solid var(--border)' : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      {/* Logo */}
      <a href="#hero" className="font-mono-custom text-lg font-bold gradient-text no-underline" style={{ cursor: 'none' }}>
        GS.
      </a>

      {/* Desktop links */}
      <ul className="hidden md:flex items-center gap-10 list-none">
        {NAV_LINKS.map(({ label, href }) => {
          const id = href.slice(1);
          return (
            <li key={id}>
              <a
                href={href}
                style={{
                  color: active === id ? 'var(--text)' : 'var(--text2)',
                  textDecoration: 'none',
                  fontSize: '0.8rem',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  fontWeight: 500,
                  cursor: 'none',
                  transition: 'color 0.25s',
                  position: 'relative',
                }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--text)')}
                onMouseLeave={e => (e.currentTarget.style.color = active === id ? 'var(--text)' : 'var(--text2)')}
              >
                {label}
                {active === id && (
                  <span
                    style={{
                      position: 'absolute', bottom: '-4px', left: 0,
                      width: '100%', height: '1px',
                      background: 'var(--accent)',
                      borderRadius: '1px',
                    }}
                  />
                )}
              </a>
            </li>
          );
        })}
      </ul>

      {/* Mobile hamburger */}
      <button
        className="md:hidden flex flex-col gap-1.5 p-2"
        style={{ background: 'none', border: 'none', cursor: 'none' }}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        {[0, 1, 2].map(i => (
          <span
            key={i}
            style={{
              display: 'block', width: '22px', height: '1.5px',
              background: 'var(--text2)',
              transition: 'all 0.3s',
              transformOrigin: 'center',
              transform:
                menuOpen
                  ? i === 0 ? 'rotate(45deg) translateY(7px)'
                  : i === 1 ? 'scaleX(0)'
                  : 'rotate(-45deg) translateY(-7px)'
                  : 'none',
            }}
          />
        ))}
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div
          className="md:hidden absolute top-full left-0 right-0 py-4 px-8 flex flex-col gap-4"
          style={{ background: 'rgba(10,10,15,0.98)', borderBottom: '1px solid var(--border)' }}
        >
          {NAV_LINKS.map(({ label, href }) => (
            <a
              key={href}
              href={href}
              style={{ color: 'var(--text2)', textDecoration: 'none', fontSize: '0.9rem', cursor: 'none' }}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
